import React, { useContext, useMemo } from 'react';
import { useQuery } from '@apollo/client';
import wrapperQuery from '../Queries/LeverantorAttestWrapperQuery.gql';
import { ActiveDatabaseContext } from '../../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import { LeverantorAttestWrapperContext } from '../Contexts/LeverantorAttestWrapperContext';
import {
  LeverantorAttestWrapperQuery,
  LeverantorAttestWrapperQueryVariables,
} from '../Queries/_QueryTypes/LeverantorAttestWrapperQuery';
import { rutinInfos } from '../../../../_Common/Const/RutinInfo';

interface IProps extends React.PropsWithChildren {}

const LeverantorAttestWrapper: React.FC<IProps> = ({ children }) => {
  const { activeDatabase } = useContext(ActiveDatabaseContext);
  const wrapperQueryResult = useQuery<
    LeverantorAttestWrapperQuery,
    LeverantorAttestWrapperQueryVariables
  >(wrapperQuery, {
    variables: { dbNames: [activeDatabase ?? ''] },
    fetchPolicy: 'cache-and-network',
  });

  const hasReadOnlyAccess = useMemo(() => {
    const readonly = wrapperQueryResult.data?.me?.[0]?.allowedroutines
      ?.find(result => result.dbname === activeDatabase)
      ?.readonlyroutines?.includes(
        rutinInfos.rtnVisaLeverantorsAttester.rutinID
      );

    return Boolean(readonly);
  }, [activeDatabase, wrapperQueryResult.data?.me]);
  return (
    <LeverantorAttestWrapperContext.Provider
      value={{ routineIsReadOnly: hasReadOnlyAccess }}
    >
      {children}
    </LeverantorAttestWrapperContext.Provider>
  );
};

export default LeverantorAttestWrapper;
